<template>
  <v-container fluid class="footer-container mb-0 pt-6 pb-8 text-center">
    <v-row justify="center">
      <v-col cols="12" md="6">
        <h2 class="mb-4 text-white font-weight-bold text-h6 custom-title">
          FALE COMIGO PELOS SEGUINTES LINKS (clique abaixo):
        </h2>

        <!-- Lista de redes sociais organizadas lado a lado -->
        <v-list density="compact" class="contact-list" bg-color="transparent">
          <v-list-item>
            <v-list-item-title>
              <a href="http://clubedoslocutores.com.br/locutores/gustavo-vargas" target="_blank"
                rel="noopener noreferrer" class="contact-link" aria-label="Clube dos Locutores">
                <i class="mdi mdi-microphone"></i>
                Clube dos Locutores
              </a>
            </v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>
              <a href="https://www.instagram.com/gustavovargaslegustavoice" target="_blank" rel="noopener noreferrer"
                class="contact-link" aria-label="Instagram Gustavo Vargas">
                <i class="mdi mdi-instagram"></i>
                gustavovargaslegustavoice
              </a>
            </v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>
              <a href="https://youtube.com/@gustavovargasloc?si=JA79cyohJ0KPSZd3" target="_blank"
                rel="noopener noreferrer" class="contact-link" aria-label="Canal do YouTube Gustavo Vargas">
                <i class="mdi mdi-youtube"></i>
                @gustavovargasloc
              </a>
            </v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>
              <a href="https://wa.me/5521985524510" target="_blank" rel="noopener noreferrer"
                class="contact-link" aria-label="WhatsApp Gustavo Vargas">
                <i class="mdi mdi-whatsapp"></i>
                5521985524510
              </a>
            </v-list-item-title>
          </v-list-item>


          <v-list-item>
            <v-list-item-title>
              <a href="mailto:gustavovargasloc@gmail.com" class="contact-link" aria-label="E-mail Gustavo Vargas">
                <i class="mdi mdi-email"></i>
                gustavovargasloc@gmail.com
              </a>
            </v-list-item-title>
          </v-list-item>

        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "RodapeInfo",
};
</script>

<style scoped>
.footer-container {
  background: linear-gradient(to bottom, #240078, #19014e);
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.text-white {
  color: #ffffff;
}

.custom-title {
  font-family: "Noto Sans", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: italic;
  font-variation-settings:
    "wdth" 100;
  letter-spacing: 0.02em;
}

.contact-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* Permite quebrar os itens para a próxima linha se necessário */
  justify-content: center;
  gap: 1.6rem;
  font-size: clamp(1rem, 0.8rem + 0.45vw, 1.2rem);
  padding: 0;
}

.contact-link {
  text-transform: none;
  font-weight: 400;
  text-decoration: none;
  color: #e9e9f6;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  transition: color 0.2s ease;
}

.contact-link:hover,
.contact-link:focus-visible {
  color: #00f5ff;
}

.contact-link i {
  font-size: 1.05em;
}

@media (max-width: 768px) {
  .contact-list {
    flex-direction: column;
    gap: 0.8rem;
  }
}
</style>
